import { useState, useEffect } from "react";
import { useUserStore } from "context/useUserStore";
import ImageManagerModal from "./ImageManagerModal";
import SpecificAPI from "services/SpecificApi";
import { ClipLoader } from "react-spinners";

const ImageLibrary = ({
  value = null,
  onChange,
  label = "Upload Image",
  aspectRatio = 1,
  className = "",
  schoolId,
}) => {
  const [preview, setPreview] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!value) {
      setPreview(null);
      return;
    }
    const fetchSignedUrl = async () => {
      try {
        setLoading(true);

        // Extract IDs from URL
        const parts = value.split("/");
        const schoolId = parts[parts.length - 2];
        const resourceId = parts[parts.length - 1];

        const data = await SpecificAPI.getResourceURL(resourceId, schoolId);

        setPreview(data?.["signed-url"]);
      } catch (error) {
        console.error("Failed to fetch signed URL", error);
        setPreview(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSignedUrl();
  }, [value]);

  const handleSelect = (url) => {
    setPreview(url);
    onChange?.(url);
  };

  const handleDelete = () => {
    setPreview(null);
    onChange?.(null);
  };

  return (
    <>
      <div className={`img-upload ${className}`}>
        {loading ? (
          <div className="img-upload__loading">
            <ClipLoader size={40} color="var(--primary-icon)" />
          </div>
        ) : preview ? (
          <div className="img-upload__preview-wrapper">
            <img
              src={preview}
              alt="Preview"
              className="img-upload__preview-img"
            />
            <div className="img-upload__preview-actions">
              <button
                className="img-upload__action-btn img-upload__action-btn--edit"
                onClick={() => setModalOpen(true)}
                title="Edit"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                  <path d="m15 5 4 4" />
                </svg>
              </button>
              <button
                className="img-upload__action-btn img-upload__action-btn--danger"
                onClick={handleDelete}
                title="Delete"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                </svg>
              </button>
            </div>
          </div>
        ) : (
          <button
            className="img-upload__dropzone"
            onClick={() => setModalOpen(true)}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            <span className="img-upload__dropzone-text">{label}</span>
            <span className="img-upload__dropzone-hint">Click to browse</span>
          </button>
        )}
      </div>

      <ImageManagerModal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
        onSelectImage={handleSelect}
        selectedImage={preview}
        loading={loading}
        setLoading={setLoading}
        schoolId={schoolId}
      />
    </>
  );
};

export default ImageLibrary;
